module.exports = __webpack_public_path__ + "img/box-skins-blue-bak.887f1fcd.jpg";